import {
  fetchWrapper,
  getAuthenticatedRequest,
  patchAuthenticatedRequest,
} from "../../utils/API/api.ts";
import {
  EVENT_CREATE_FAIL,
  EVENT_CREATE_REQUEST,
  EVENT_CREATE_SUCCESS,
  EVENT_EDIT_FAIL,
  EVENT_EDIT_REQUEST,
  EVENT_EDIT_SUCCESS,
  EVENT_GET_SUCCESS,
  EVENT_GET_FAIL,
  EVENT_GET_REQUEST,
  EVENT_PERMISSIONS_USER,
  EVENT_PERMISSIONS_ERROR,
  EVENT_PERMISSIONS_CURRENT_TAB,
} from "../constants/eventConstants";

// GET SINGLE EVENT
export const getSingleEvent =
  ({ eventId, queries }) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: EVENT_GET_REQUEST });

      let url = `${process.env.REACT_APP_SERVER_URL_LEADS}/event/${eventId}`;
      if (queries) {
        url = url + queries;
      }

      const response = await fetch(
        url
        // {
        //   method: "GET",
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: `bearer ${accessToken}`,
        //   },
        // }
      );

      // if (response.status === 403) {
      //   alert("unAuthorized!!");
      //   window.location.pathname = "/events";
      // }
      const res = await response.json();
      // if (response.data.message) {
      //   throw new Error(data.message);
      // }

      dispatch({ type: EVENT_GET_SUCCESS, payload: res.savedEventConfig });
    } catch (error) {
      dispatch({ type: EVENT_GET_FAIL, payload: error });
    }
  };

// Create event
export const createEvent =
  ({
    title,
    startDate,
    endDate,
    shortDescription,
    location,
    coverImage,
    isMockEvent,
    isRegistrationApproval,
    // eventTag,
  }) =>
  async (dispatch, getState) => {
    const imageUrls = [
      "https://s3.ap-south-1.amazonaws.com/app.warpbay1/0c1e73258c6abaa03b93a3cc38ea8dc3",
      "https://s3.ap-south-1.amazonaws.com/app.warpbay1/f70e3032226e5e7d2193d72da3e2ae60",
      "https://s3.ap-south-1.amazonaws.com/app.warpbay1/ddd188e2b8a036c4db994930468d8df7",
    ];
    const getRandomImage =
      imageUrls[Math.floor(Math.random() * imageUrls.length)];

    try {
      dispatch({ type: EVENT_CREATE_REQUEST });

      const response = await fetchWrapper(`/event`, {
        method: "POST",
        body: JSON.stringify({
          title,
          startDate,
          endDate,
          shortDescription,
          location,
          coverImage: getRandomImage,
          isMockEvent: isMockEvent === true ? true : false,
          isRegistrationApproval: isRegistrationApproval,
          // eventTag,
        }),
      });

      const data = response.data;

      if (data.message) {
        throw new Error(data.message);
      }

      dispatch({ type: EVENT_CREATE_SUCCESS, payload: data });
    } catch (error) {
      console.log(error);

      dispatch({ type: EVENT_CREATE_FAIL, payload: error });
    }
  };

// edit event
export const editEvent = (eventInfo) => async (dispatch, getState) => {
  try {
    dispatch({ type: EVENT_EDIT_REQUEST });

    const response = await fetchWrapper(`/event`, {
      method: "PATCH",
      body: JSON.stringify({ ...eventInfo }),
    });

    const data = response.data;

    if (data.message) {
      throw new Error(data.message);
    }

    dispatch({ type: EVENT_EDIT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: EVENT_EDIT_FAIL, payload: error });
  }
};

export const getEventPermissions =
  (eventInfo) => async (dispatch, getState) => {
    try {
      const response = await getAuthenticatedRequest(
        `/event/${eventInfo?.eventId}/getUserPermissions`
      );

      const data = response.data?.userPermission;

      dispatch({
        type: eventPermissions,
        payload: {
          globalRole: data?.globalRole,
          tabPermissions: data?.tabPermissions,
        },
      });
    } catch (error) {
      dispatch({ type: EVENT_PERMISSIONS_ERROR, payload: { error: true } });
    }
  };

export const eventPermissions = (payload) => ({
  type: EVENT_PERMISSIONS_USER,
  payload,
});

export const currentTabPermissions = (payload) => ({
  type: EVENT_PERMISSIONS_CURRENT_TAB,
  payload,
});

export const updateActivityLogs =
  ({ permissionsEventId, tab, action, permissionsId, notes }) =>
  async (dispatch, getState) => {
    try {
      await patchAuthenticatedRequest(
        `/event/${permissionsEventId}/updateActivityLogs`,
        {
          notes: notes,
          action: action,
          tab: tab,
        }
      );
    } catch (error) {
      console.log(error);
    }
  };
